export const MAP_TILES = {
  GOOGLE: 'google',
  IGN: 'ign',
  NONE: 'none',
} as const;

export type MapTiles = (typeof MAP_TILES)[keyof typeof MAP_TILES];

export const IGN_MAX_ZOOM = 19;
export const GOOGLE_MAX_ZOOM = 20;
